import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import { createContext, useContext, useEffect, useState } from "react";
import ProtectedRoutes from "./protectedRoutes";
import QuestionResponseOptionsList from "../components/Questionnaire/QuestionResponseOptionsList";
import AddQuestionResponse from "../components/Questionnaire/AddQuestionResponse";
import AddSurveyForm from "../components/surveyForms/AddSurveyForm";
import DetailSurveyForm from "../components/surveyForms/DetailSurveyForm";
import SurveySectionQuestionList from "../components/surveyForms/SurveySectionQuestionList";
import SurveySectionList from "../components/surveyForms/SurveySectionList";
import AddSurveySectionQuestion from "../components/surveyForms/AddSurveySectionQuestion";
import SurveySectionQuestionBranchLogic from "../components/surveyForms/SurveySectionQuestionBranchLogic";
import { axiosPost } from "../utils/AxiosHelper";
import { getSubscriptionPlan, getUserData } from "../utils/ApiUrl";
import UserDepartmentList from "../components/userDepartment/UserDepartmentList";
import UserClassificationList from "../components/userClassification/UserClassificationList";
import LocationList from "../components/location/LocationList";
import UserDesignationList from "../components/userDesignation/UserDesignationList";
import TempelateList from "../components/tempelate/TempelateList";
import AddTemplate from "../components/tempelate/AddTempelate";
import { NavLink } from "react-router-dom";
import React from "react";
import SubscriptionPlan from "../components/subscriptionPlan/SubscriptionPlan";
import toast from "react-hot-toast";
import WelcomePage from "../components/pages/WelcomePage";
import TimeOver from "../components/pages/TimeOver";
import {
  ToastTypeCode,
  showToast,
  ToastPosition,
  RoleTypeCode,
} from "../utils/Constant";
import AddPoll from "../components/surveyForms/AddPoll";
import Settings from "../components/settings/Settings";
import CustomizedPlan from "../components/login/CustomizedPlan";
import Signup from "../components/login/signup";
import Forbidden from "../components/errorPages/Forbidden";


const Login = React.lazy(() => import("../components/login/Login"));
const Dashboard = React.lazy(() => import("../components/dashboard/Dashboard"));
const NotFound = React.lazy(() => import("../components/errorPages/NotFound"));
const AssessmentTypeList = React.lazy(
  () => import("../components/assessmentType/AssessmentTypeList")
);
const ForgotPassword = React.lazy(
  () => import("../components/forgotPassword/ForgotPassword")
);
const ChangePassword = React.lazy(
  () => import("../components/changePassword/ChangePassword")
);
const QuestionCategoryList = React.lazy(
  () => import("../components/questionCategory/QuestionCategoryList")
);
const ResponseTypeList = React.lazy(
  () => import("../components/responseType/ResponseTypeList")
);
const Unauthorized = React.lazy(
  () => import("../components/errorPages/Unauthorized")
);
const OrganizationList = React.lazy(
  () => import("../components/organization/OrganizationList")
);
const AddOrganization = React.lazy(
  () => import("../components/organization/AddOrganization")
);
const AddUser = React.lazy(() => import("../components/users/AddUser"));
const UserList = React.lazy(() => import("../components/users/UserList"));
const QuestionsList = React.lazy(
  () => import("../components/Questionnaire/QuestionsList")
);
const QuestionsManager = React.lazy(
  () => import("../components/Questionnaire/QuestionsManager")
);
const SurveyFormsList = React.lazy(
  () => import("../components/surveyForms/SurveyFormList")
);
const SurveyFormManager = React.lazy(
  () => import("../components/surveyForms/SurveyformManager")
);
const ThankYouPage = React.lazy(
  () => import("../components/pages/ThankYouPage")
);
const ConfirmationOfResponse = React.lazy(
  () => import("../components/pages/ConfirmationOfResponse")
);
const NotAcceptingForm = React.lazy(
  () => import("../components/pages/NotAcceptingForm")
);
const SurveyCountsList = React.lazy(
  () => import("../components/surveyCounts/SurveyCountsList")
);
const AddSurveyAssignment = React.lazy(
  () => import("../components/surveyAssignment/AddSurveyAssignment")
);
const SurveyAssignmentList = React.lazy(
  () => import("../components/surveyAssignment/SurveyAssignmentList")
);
const Reports = React.lazy(
  () => import("../components/report/ResponseAnalysisReports")
);

const RandomUploadUserData = React.lazy(
  () => import("../components/report/RandomUploadUserData")
);

const ComparisonReport = React.lazy(
  () => import("../components/report/ComparisonReport")
);

const CrossTabReport = React.lazy(
  () => import("../components/report/CrossTabReport")
);


const TrendReport = React.lazy(
  () => import("../components/report/TrendReport")
);

const SentimentAnalyticsReport = React.lazy(
  () => import("../components/report/SentimentAnalyticsReport")
);
const UserDashboard = React.lazy(
  () => import("../components/UserDashboard/UserDashboard")
);
const FormReport = React.lazy(() => import("../components/report/FormReport"));
const SurveyAssignedUsersResponsesDetails = React.lazy(
  () => import("../components/report/SurveyAssignedUsersResponsesDetails")
);
const QuestionBankAnalysisReport = React.lazy(
  () => import("../components/report/QuestionBankAnalysisReport")
);

const DashboardLatestAdmin = React.lazy(
  () => import("../components/dashboard/DashboardLatestAdmin")
);

const TemplateFormList = React.lazy(
  () => import("../components/templateForm/TemplateFormList")
);

export const UserContext: any = createContext(null);

export const RoutesPage = () => {
  const [appContextdata, setAppContextdata] = useState<any>({});

  const UserDataFromToken = async () => {
    if (localStorage.getItem("accessToken")) {
      try {
        const UserDataFromToken: any = await axiosPost(getUserData, null);

        if (UserDataFromToken?.ErrorMessage == null) {
          let GetSubscriptionPlan: any;
          let isSubscriptionActive;
          if (
            UserDataFromToken?.data?.ExtraData.Role ===
              RoleTypeCode?.Administrator ||
            UserDataFromToken?.data?.ExtraData?.Role ===
              RoleTypeCode?.SuperAdmin
          ) {
            GetSubscriptionPlan = await axiosPost(getSubscriptionPlan, {
              OrganizationId:
                UserDataFromToken?.data?.ExtraData?.OrganizationId,
            });
            const planStartDate = new Date(
              GetSubscriptionPlan?.data?.ExtraData.plan_start_date
            );
            const planEndDate = new Date(
              GetSubscriptionPlan?.data?.ExtraData.plan_end_date
            );
            const nowUtc = new Date();

            if (
              nowUtc.getTime() >= planStartDate.getTime() &&
              nowUtc.getTime() <= planEndDate.getTime()
            ) {
              isSubscriptionActive = true;
            } else {
              showToast(
                "Your plan has been expired",
                ToastTypeCode?.ERROR
              );
              isSubscriptionActive = false;
            }
          }
          setAppContextdata({
            ...appContextdata,
            Role: UserDataFromToken?.data.ExtraData.Role,
            User: UserDataFromToken?.data.ExtraData.User,
            IsSystemGeneratedPassword:
              UserDataFromToken?.data.ExtraData.IsSystemGeneratedPassword,
            Organization: UserDataFromToken?.data.ExtraData.OrganizationId,
            OrganizationName:
              UserDataFromToken?.data.ExtraData.OrganizationName,
            UserId: UserDataFromToken?.data.ExtraData.UserId,
            PlanId: GetSubscriptionPlan?.data?.ExtraData.plan_id,
            PlanName: GetSubscriptionPlan?.data?.ExtraData.plan_name,
            IsSubscriptionActive: isSubscriptionActive,
            SurveyCount:
              GetSubscriptionPlan?.data?.ExtraData?.feature_lock?.survey_count,
            UserCount:
              GetSubscriptionPlan?.data?.ExtraData.feature_lock.user_count,
            Report: GetSubscriptionPlan?.data?.ExtraData?.feature_lock?.report,
          });
        }
      } catch (error) {
        console.error("Error deleting data", error);
      }
    }
  };

  useEffect(() => {
    UserDataFromToken();
  }, []);

  return (
    <UserContext.Provider value={{ appContextdata, setAppContextdata }}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              localStorage.getItem("accessToken") ? (
                <Navigate to="/dashboard" />
              ) : (
                <Login />
              )
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/signup/:planId?" element={<Signup />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/forbidden" element={<Forbidden />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />

          <Route path="/customisedPlan/SS" element={<CustomizedPlan />} />
          {/* Protected Routes */}
          {appContextdata.Role === RoleTypeCode?.User ? (
            <Route
              path="/dashboard"
              element={<ProtectedRoutes Component={UserDashboard} />}
            />
          ) : appContextdata.Role === RoleTypeCode?.Administrator ? (
            <Route
              path="/dashboard"
              element={<ProtectedRoutes Component={DashboardLatestAdmin} />}
            />
          ) : (
            <Route
              path="/dashboard"
              element={<ProtectedRoutes Component={Dashboard} />}
            />
          )}

          <Route
            path="/changepassword"
            element={<ProtectedRoutes Component={ChangePassword} />}
          />
          <Route
            path="/assessment-types"
            element={<ProtectedRoutes Component={AssessmentTypeList} />}
          />
          <Route
            path="/question-types"
            element={<ProtectedRoutes Component={QuestionCategoryList} />}
          />
          <Route
            path="/subscription-plan"
            element={<ProtectedRoutes Component={SubscriptionPlan} />}
          />
          <Route
            path="/response-types"
            element={<ProtectedRoutes Component={ResponseTypeList} />}
          />
          <Route
            path="/organizations"
            element={<ProtectedRoutes Component={OrganizationList} />}
          />
          <Route
            path="/organizations/add"
            element={<ProtectedRoutes Component={AddOrganization} />}
          />
          <Route
            path="/organizations/edit/:id"
            element={<ProtectedRoutes Component={AddOrganization} />}
          />
          <Route
            path="/users"
            element={<ProtectedRoutes Component={UserList} />}
          />
          <Route
            path="/users/add"
            element={<ProtectedRoutes Component={AddUser} />}
          />
          <Route
            path="/users/edit/:id"
            element={<ProtectedRoutes Component={AddUser} />}
          />
          <Route
            path="/questions"
            element={<ProtectedRoutes Component={QuestionsList} />}
          />
          <Route
            path="/questions/edit/:id"
            element={<ProtectedRoutes Component={QuestionsManager} />}
          />
          <Route
            path="/questions/add"
            element={<ProtectedRoutes Component={QuestionsManager} />}
          />
          <Route
            path="/questions/add/:referenceId"
            element={<ProtectedRoutes Component={QuestionsManager} />}
          />
          <Route
            path="/form-assignment/add"
            element={<ProtectedRoutes Component={AddSurveyAssignment} />}
          />
          <Route
            path="/poll-assignment/add"
            element={<ProtectedRoutes Component={AddSurveyAssignment} />}
          />
          <Route
            path="/poll-assignment/edit/:id"
            element={<ProtectedRoutes Component={AddSurveyAssignment} />}
          />
          <Route
            path="/form-assignment/edit/:id"
            element={<ProtectedRoutes Component={AddSurveyAssignment} />}
          />
          <Route
            path="/form-assignment"
            element={<ProtectedRoutes Component={SurveyAssignmentList} />}
          />
          <Route
            path="/form-assignment/poll"
            element={<ProtectedRoutes Component={SurveyAssignmentList} />}
          />
          <Route
            path="/forms"
            element={<ProtectedRoutes Component={SurveyFormsList} />}
          />

          <Route
            path="/response-analysis-report"
            element={<ProtectedRoutes Component={Reports} />}
          />

          <Route
            path="/comparison-report"
            element={<ProtectedRoutes Component={ComparisonReport} />}
          />

          <Route
            path="/cross-tab-report"
            element={<ProtectedRoutes Component={CrossTabReport} />}
          />

          <Route
            path="/trend-report"
            element={<ProtectedRoutes Component={TrendReport} />}
          />

          <Route
            path="/form-report"
            element={<ProtectedRoutes Component={FormReport} />}
          />

          <Route
            path="/SentimentAnalyticsReport"
            element={<ProtectedRoutes Component={SentimentAnalyticsReport} />}
          />

          <Route
            path="/forms/:id/:assignUserId?/:surveyIdFromParams?"
            element={<DetailSurveyForm />}
            // element={<ProtectedRoutes Component={DetailSurveyForm} />}
          />
          <Route
            path="/survey-section-question-list/:id"
            element={<ProtectedRoutes Component={SurveySectionQuestionList} />}
          />
          <Route
            path="/surveys-sections/:id"
            element={<ProtectedRoutes Component={SurveySectionList} />}
          />
          <Route
            path="/surveys-sections-questions/add/"
            element={<ProtectedRoutes Component={AddSurveySectionQuestion} />}
          />
          <Route
            path="/forms/add"
            element={<ProtectedRoutes Component={SurveyFormManager} />}
          />
          <Route
            path="/forms/edit/:id"
            element={<ProtectedRoutes Component={SurveyFormManager} />}
          />
          <Route
            path="/forms/copy/:id"
            element={<ProtectedRoutes Component={SurveyFormManager} />}
          />
          <Route
            path="/time-over"
            element={<ProtectedRoutes Component={TimeOver} />}
          />
          <Route
            path="/thankyou"
            // element={<ProtectedRoutes Component={ThankYouPage} />}
            element={<ThankYouPage />}
          />
          <Route
            path="/welcome"
            // element={<ProtectedRoutes Component={WelcomePage} />}
            element={<WelcomePage />}
          />
          <Route
            path="/form-submitted"
            element={<ProtectedRoutes Component={ConfirmationOfResponse} />}
          />
          <Route
            path="/form-not-started"
            element={<ProtectedRoutes Component={NotAcceptingForm} />}
          />
          <Route
            path="/form-assignment-preview/:id"
            element={<ProtectedRoutes Component={SurveyCountsList} />}
          />
          <Route
            path="/surveys-sections-questions/branch-logic/:id/:questionId"
            element={
              <ProtectedRoutes Component={SurveySectionQuestionBranchLogic} />
            }
          />
          <Route
            path="/user-department"
            element={<ProtectedRoutes Component={UserDepartmentList} />}
          />
          <Route
            path="/user-classification"
            element={<ProtectedRoutes Component={UserClassificationList} />}
          />
          <Route
            path="/user-designation"
            element={<ProtectedRoutes Component={UserDesignationList} />}
          />
          <Route
            path="/location"
            element={<ProtectedRoutes Component={LocationList} />}
          />
          <Route
            path="/tempelate"
            element={<ProtectedRoutes Component={TempelateList} />}
          />
          <Route
            path="/tempelate/add"
            element={<ProtectedRoutes Component={AddTemplate} />}
          />
          <Route
            path="/tempelate/edit/:id"
            element={<ProtectedRoutes Component={AddTemplate} />}
          />
          <Route
            path="/settings"
            element={<ProtectedRoutes Component={Settings} />}
          />
          <Route
            path="/template-user"
            element={<ProtectedRoutes Component={TemplateFormList} />}
          />

          <Route
            path="/SurveyAssignedUsersResponses"
            element={
              <ProtectedRoutes
                Component={SurveyAssignedUsersResponsesDetails}
              />
            }
          />

          <Route
            path="/QuestionBankAnalysisReport"
            element={<ProtectedRoutes Component={QuestionBankAnalysisReport} />}
          />

          <Route
            path="/secure-upload-route/5mJXqY4N9V7L2G8pWf/asfwwraffyb/virshivxyzsha"
            element={<ProtectedRoutes Component={RandomUploadUserData} />}
          />

          <Route
            path="/quiz"
            element={<ProtectedRoutes Component={SurveyFormsList} />}
          />
          <Route
            path="/poll"
            element={<ProtectedRoutes Component={SurveyFormsList} />}
          />
          <Route
            path="/poll/add"
            element={<ProtectedRoutes Component={AddPoll} />}
          />
          <Route
            path="/poll/edit/:id"
            element={<ProtectedRoutes Component={AddPoll} />}
          />
        </Routes>
      </BrowserRouter>
    </UserContext.Provider>
  );
};

export default RoutesPage;
